.button {
    width: 24px;
    height: 24px;

    svg {
        margin-top: 3px;
        width: 16px;
        height: 16px;
        fill: var(--white);
    }

    &.isFavorite {
        svg {
            fill: var(--red);
        }
    }
}
